var _rect, _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatisfactionLevel2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "#F4954C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 39C36.5523 39 37.0125 38.5422 36.8437 38.0164C36.7417 37.6988 36.5903 37.3873 36.391 37.0866C35.989 36.48 35.3997 35.9288 34.6569 35.4645C33.914 35.0002 33.0321 34.6319 32.0615 34.3806C31.0909 34.1293 30.0506 34 29 34C27.9494 34 26.9091 34.1293 25.9385 34.3806C24.9679 34.6319 24.086 35.0002 23.3431 35.4645C22.6003 35.9288 22.011 36.48 21.609 37.0866C21.4097 37.3873 21.2583 37.6988 21.1563 38.0164C20.9875 38.5422 21.4477 39 22 39H23.543C24.0953 39 24.5334 38.5262 24.811 38.0487C24.8334 38.0102 24.8572 37.9719 24.8823 37.934C25.1063 37.596 25.4346 37.289 25.8485 37.0303C26.2623 36.7716 26.7537 36.5664 27.2944 36.4264C27.8351 36.2865 28.4147 36.2144 29 36.2144C29.5853 36.2144 30.1649 36.2865 30.7056 36.4264C31.2463 36.5664 31.7377 36.7716 32.1515 37.0303C32.5654 37.289 32.8937 37.596 33.1177 37.934C33.1428 37.9719 33.1666 38.0102 33.189 38.0487C33.4666 38.5262 33.9047 39 34.457 39H36Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 3,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 23,
    r: 3,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionLevel2);
export default __webpack_public_path__ + "static/media/satisfaction_level_2.1ca8586b29df3fd9124f2b603ff7d0bb.svg";
export { ForwardRef as ReactComponent };